module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "sec_front"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Maps")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("North Africa")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Italy and the Adriatic")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Burma")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Operation Jaywick")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("The First Chindit Expedition")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("The Second Chindit Expedition")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Greece and the Aegean")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("France (and insert: Operation Freshman)")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74955de2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Maps.vue
// module id = 72
// module chunks = 0